import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class AsGeoJson extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.asgeojson',
        group: 'Parsers',
        title: 'ST as GeoJSON',
        description: `
      This component generates a new column with the GeoJSON representation of geographies in another column.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Column with geographies definition',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    if (connection.type === Provider.DatabricksRest) {
      return dedent`SELECT /*+ REPARTITION(40) */
                *, ST_ASGEOJSON(${connection.processInputGeogColumn(params.geo as string)}) AS ${params.geo}_geojson
              FROM ${connection.quoteName(params.source as string)}`
    } else if (connection.type === Provider.Oracle) {
      const geoColumn = params.geo as string
      const geojsonColumn = `${params.geo}_geojson`
      return `SELECT SDO_UTIL.TO_GEOJSON(t.${geoColumn}) AS ${geojsonColumn}, t.* FROM ${connection.quoteName(
        params.source as string
      )} t`
    } else {
      return dedent`SELECT *, ST_ASGEOJSON(${connection.processInputGeogColumn(params.geo as string)}) AS ${
        params.geo
      }_geojson
                      FROM ${connection.quoteName(params.source as string)}`
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_geojson`,
      type: ColumnDataType.String
    })
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { AsGeoJson }
